import { FilterCategory } from "../Enums";

export class ToolFilterStateItem {
  categoryName: string;
  id: string;
  value: string;
  valueTitle: string;
  public get isBoolean() {
    return this.id === FilterCategory.IsActive;
  }

  constructor(categoryName: string, id: string, value: string, valueTitle: string) {
    this.categoryName = categoryName;
    this.id = id;
    this.value = value;
    this.valueTitle = valueTitle;
  }
}
